import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: "https://501cf986a062f927016596293643e77b@o4508966971965440.ingest.us.sentry.io/4508966972358656",
  release: "",
  environment: "staging",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.25,
  // Mapbox throws this on crawlers and browsers without WebGL. Each tree page groups as its own issue.
  ignoreErrors: ["Failed to initialize WebGL"],
  // HubSpot's tracker throws on some query strings. It isn't our code and its URL changes constantly.
  denyUrls: [/hs-analytics\.net/],
});
